export const environment = {
    environmentFileName: 'environment.preprod.ts',
    production: false,
    apiMocking: false,
    abaqusApiUrl: 'https://abaqus-prepro.digital.tecnalia.dev',
    abaqusApiKey: 'mkN40RSR.GD8QkiRi04imKJwuowjJELEcvQEwDZu4',
    iqarusApiUrl: 'https://aqre-qa.ap.basf.net',
    iqarusApiKey: 'XjlxPTDMbiEaellM4v5bWwrJfJlrR5QRVaYSavdmol8',
    speadApiUrl: 'https://app-qa.roqs.basf.net/radar_api',
    speadApiKey: 'c38f68ca88599426c65eb80470adc76f27cd3501',
    faviconFile: 'favicon-orange.ico',
    environmentNameSuffix: ' - prepro'
};
